// @ vendors
const React = require('react');
const { set, isObject, map } = require('lodash');
const PropTypes = require('prop-types');
const get = require('lodash/object/get');

// @core
const { formatText } = require('core/i18n').i18n;

// @commons
const { InputSafe } = require('commonsComponents/inputSafe');

// @components
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @constants
const {
    EMPLOYMENT_SITUATION: {
        RENTISTA_OTROS,
        SIN_ACTIVIDAD_ECONOMICA,
        PENSIONISTA,
        AUTONOMO,
        PARADO,
        FUNCIONARIO_MUFACE
    },
    getWorkInfo
} = require('constants/mortgageRequestHolderData');
const ACTUAL_YEAR = new Date().getFullYear();

class CurrentInfo extends React.Component {
    constructor(props) {
        super(props);

        this.values = props.values;

        this.disable = {
            contractType: false,
            jobIncorporationDate: false
        };

        this.showError = {
            jobSituation: this.isError(get(props, 'values.jobSituation', '')),
            contractType: false,
            jobIncorporationDate: {
                month: false,
                year: false
            },
            studyLevel: false
        };

        this.jobIncorporationDateInputs = {};

        this.handleValidateJobSituation = this.handleValidateJobSituation.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleValidateDate = this.handleValidateDate.bind(this);
    }

    componentDidMount() {
        this.handleValidateJobSituation({ value: this.values.jobSituation });
    }

    handleOnChange(name, option) {
        this.values[name] = option.value;
        this.props.onHandleMufaceOption(null) || this.forceUpdate();
    }

    handleValidateDate(el) {
        const { name, value } = el.target;
        const stringMatch = value.match( /\D+/g );
        const incomingValue = parseInt(value, 10);

        if (name === 'jobIncorporationDate.month') {
            if (incomingValue > 12 || stringMatch) {
                return false;
            }

            value.length === 2 && this.jobIncorporationDateInputs.year.el.focus();
        } else {
            if (incomingValue > ACTUAL_YEAR || stringMatch) {
                return false;
            }
        }

        set(this.values, name, value);
        this.props.onHandleMufaceOption(null) || this.forceUpdate();
    }

    handleValidateJobSituation(option) {
        const { value } = option;
        let isMufaceSelected = false;

        this.values.jobSituation = value;
        this.disable.contractType = false;
        this.disable.jobIncorporationDate = false;
        /**
         * Si la situación laboral es alguna de estas, deshabilita los campos tipo de contrato y fecha de incorporacion
         */
        if (
            [RENTISTA_OTROS, SIN_ACTIVIDAD_ECONOMICA, PENSIONISTA, AUTONOMO, PARADO].find(
                val => val === value
            )
        ) {
            this.disable.contractType = true;
            this.disable.jobIncorporationDate = true;
            this.values.jobIncorporationDate.month = '';
            this.values.jobIncorporationDate.year = '';
            this.values.contractType = '';
            this.forceUpdate();
        } else if (value === FUNCIONARIO_MUFACE) {
            // deshabilitar ceaCode y cambiar copies del drag n drop
            isMufaceSelected = true;
        }

        // Update the error
        this.showError.jobSituation = this.isError(value);

        /**
         * la fn "onHandleMufaceOption" renderiza todo si retorna true, si no, hay que renderizar el componente
         */
        this.props.onHandleMufaceOption(isMufaceSelected) || this.forceUpdate();
    }

    isError(value) {
        return value === '' || value === 'UNKNOWN';
    }

    validateInputsData() {
        let errr = false;

        /**
         * revisar si hay errores.
         * Si todo esta ok envía los valores
         */
        map(this.values, (value, idx) => {
            if (
                isObject(value) &&
                !this.disable.contractType &&
                !this.disable.jobIncorporationDate
            ) {
                // es la fecha
                const jobError = {
                    month: this.values.jobIncorporationDate.month.length !== 2,
                    year: this.values.jobIncorporationDate.year.length !== 4
                };
                this.showError.jobIncorporationDate = jobError;

                if (jobError.month || jobError.year) {
                    errr = true;
                }
            } else {
                this.showError[idx] = this.isError(value);
                if (this.showError[idx]) {
                    if (idx === 'contractType' && this.disable.contractType) {
                        // si el tipo de contrato esta deshabilitado, no hay error si tiene alguno de los valores
                        errr = this.showError[idx] = false;
                    } else {
                        errr = this.showError[idx];
                    }
                }
            }
        });

        return errr ? false : this.values;
    }

    render() {
        const { disable } = this.props;
        const workInfo = getWorkInfo();
        return (
            <div>
                <div className="row separator">
                    <div className="col-md-6">
                        <OKSelect
                            clearable={false}
                            searchable={false}
                            name="jobSituation"
                            label={formatText('mortgageRequestWorkData-jobSituationPlaceholder')}
                            placeholder={formatText(
                                'mortgageRequestWorkData-jobSituationPlaceholder'
                            )}
                            options={workInfo.situacionLaboral}
                            onChange={this.handleValidateJobSituation}
                            value={this.values.jobSituation}
                            errorState={this.showError.jobSituation}
                            errorMessage={this.props.inputErrorText}
                            disabled={disable}
                        />
                    </div>
                    <div className="col-md-6">
                        <OKSelect
                            clearable={false}
                            searchable={false}
                            name="contractType"
                            label={formatText('mortgageRequestWorkData-contractTypeLabel')}
                            placeholder={formatText(
                                'mortgageRequestWorkData-contractTypePlaceholder'
                            )}
                            onChange={option => this.handleOnChange('contractType', option)}
                            options={workInfo.contratoTrabajo}
                            value={this.values.contractType}
                            disabled={this.disable.contractType || disable}
                            errorState={!this.disable.contractType && this.showError.contractType}
                            errorMessage={this.props.inputErrorText}
                        />
                    </div>
                </div>
                <div className="row separator">
                    <div className="col-md-6">
                        <div className="split-fields form__group-inputs">
                            <label>
                                {formatText('mortgageRequestWorkData-jobIncorporationDateLabel')}
                            </label>
                            <div className="split__children">
                                <div className="row clear-split">
                                    <div className="col-md-4  md-form-group">
                                        <InputSafe
                                            maxLength={2}
                                            name="jobIncorporationDate.month"
                                            type="text"
                                            placeholder={formatText('common-month').toLowerCase()}
                                            value={this.values.jobIncorporationDate.month}
                                            ref={input =>
                                                (this.jobIncorporationDateInputs.month = input)}
                                            onChange={this.handleValidateDate}
                                            disabled={this.disable.jobIncorporationDate || disable}
                                            errorState={!this.disable.jobIncorporationDate && this.showError.jobIncorporationDate.month}
                                            errorMessage={this.props.inputErrorText}
                                        />
                                    </div>
                                    <div className="col-md-4 md-form-group">
                                        <InputSafe
                                            maxLength={4}
                                            name="jobIncorporationDate.year"
                                            type="text"
                                            placeholder={formatText('common-year').toLowerCase()}
                                            value={this.values.jobIncorporationDate.year}
                                            ref={input =>
                                                (this.jobIncorporationDateInputs.year = input)}
                                            onChange={this.handleValidateDate}
                                            disabled={this.disable.jobIncorporationDate || disable}
                                            errorState={!this.disable.jobIncorporationDate && this.showError.jobIncorporationDate.year}
                                            errorMessage={this.props.inputErrorText}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <OKSelect
                            clearable={false}
                            searchable={false}
                            name="studyLevel"
                            label={formatText('mortgageRequestWorkData-studyLevelLabel')}
                            placeholder={formatText(
                                'mortgageRequestWorkData-studyLevelPlaceholder'
                            )}
                            onChange={option => this.handleOnChange('studyLevel', option)}
                            options={workInfo.nivelEstudios}
                            value={this.values.studyLevel}
                            errorState={this.showError.studyLevel}
                            errorMessage={this.props.inputErrorText}
                            disabled={disable}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

CurrentInfo.propTypes = {
    disable: PropTypes.bool,
    values: PropTypes.object,
    inputErrorText: PropTypes.string,
    onHandleMufaceOption: PropTypes.func
};

module.exports = CurrentInfo;
